import "./Styles/listing-events.scss";
import "react-toggle/style.css";

import config from "../../app.json";
import axios from "axios";

import Pagination from "../../Components/Pagination/pagination";

import { Context } from "../../Reducers/Store";
import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Row, Col, Button } from "react-bootstrap";
import AlertComponent from "../../Components/AlertComponent";
import FieldText from "../../Components/Fields/FieldText";
import FieldSelect from "../../Components/Fields/FieldSelect";
import FieldUploadMultipart from "../../Components/Fields/FieldUploadMultipart";
import FieldTextarea from "../../Components/Fields/FieldTextarea";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFloppyDisk, faPlus } from "@fortawesome/free-solid-svg-icons";
import VideoJS from "../../Components/VideoJS/VideoJS";
import moment from "moment";

function VideoArchiveEdit() {
  let navigate = useNavigate();
  const { id } = useParams();

  const [state, dispatch] = useContext(Context);
  const [data, setData] = useState(null);

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [cover, setCover] = useState(null);
  const [picture, setPicture] = useState(null);
  const [pdf, setPDF] = useState(null);
  const [hide, setHide] = useState(false);
  const [speakerName, setSpeakerName] = useState("");
  const [speakerTitle, setSpeakerTitle] = useState("");
  const visibilities = [{ label: "Public", value: false }, { label: "Private", value: true }];
  const [uploading, setUploading] = useState(false);
  const [s3HLSPath, setS3HLSPath] = useState(null);
  const [videoTime, setVideoTime] = useState(0);
  const [videoMoments, setVideoMoments] = useState([]);
  const [newMomentName, setNewMomentName] = useState("");
  const [eventName, setEventName] = useState(null);
  const [customLinkTitle, setCustomLinkTitle] = useState(null);
  const [customLinkUrl, setCustomLinkUrl] = useState(null);
  const generalSeriesOption = { label: "General", value: null };
  const [series, setSeries] = useState(generalSeriesOption);
  const [seriesOptions, setSeriesOptions] = useState([generalSeriesOption]);

  const playerRef = React.useRef(null);

  const handlePlayerReady = (player) => {
    playerRef.current = player;

    // You can handle player events here, for example:
    player.on('waiting', () => {
      console.log('player is waiting');
    });

    player.on('dispose', () => {
      console.log('player will dispose');
    });

    player.on('timeupdate', function (x) {
      const currentTime = player.currentTime();
      setVideoTime(currentTime);
      console.log(currentTime);
    });
  };


  useEffect(() => {
    if (id)
      fetchEvent();

    fetchSeriesOptions();
  }, [id]);

  const fetchSeriesOptions = () => {
    axios.post(config.API + "/api/series/getSeriesSelect", null).then((res) => {
      var parsed = res.data.$values?.map(x => ({ value: x.id, label: x.name })) ?? [];
      setSeriesOptions([generalSeriesOption, ...parsed]);
    }).catch(function (error) {
      return AlertComponent("Error", error?.response?.data?.error || error?.response?.data?.message || error?.message, { icon: `error` });
    });
  };

  const fetchEvent = () => {
    axios.post(config.API + "/api/event/getEventInstance", {
      id
    }).then((res) => {
      setData(res.data);
    }).catch(function (error) {
      return AlertComponent("Error", error?.response?.data?.error || error?.response?.data?.message || error?.message, { icon: `error` });
    });
  };

  const handleSave = (e) => {
    e.preventDefault();

    if (uploading)
      return AlertComponent("Error", "You must wait the upload finish to continue.", { icon: `error` });

    axios.post(config.API + "/api/event/saveEventInstance", {
      title,
      description,
      personName: speakerName,
      personPosition: speakerTitle,
      hide: hide?.value ?? false,
      cover,
      personPicture: picture,
      id,
      videoMoments,
      pdf,
      customLinkTitle,
      customLinkUrl,
      seriesId: series?.value ?? null
    }).then((res) => {
      AlertComponent("Success", "Video Archive was updated successfully!");
      return navigate("/videoArchive", { replace: false });
    }).catch(function (error) {
      return AlertComponent("Error", error?.response?.data?.error || error?.response?.data?.message || error?.message, { icon: `error` });
    });

  }

  useEffect(() => {
    setTitle(data?.title ?? "");
    setDescription(data?.description ?? "");
    setCover(data?.cover);
    setPicture(data?.personPicture);
    setPDF(data?.pdf);
    setHide(visibilities.find(x => x.value == data?.hide ?? false));
    setSpeakerName(data?.personName ?? "");
    setSpeakerTitle(data?.personPosition ?? "");
    setS3HLSPath(data?.s3HLSPath);
    setVideoMoments(data?.videoMoments?.$values.map(({ $id, ...item }) => item));
    setEventName(data?.eventName);
    setCustomLinkTitle(data?.customLinkTitle);
    setCustomLinkUrl(data?.customLinkUrl);
    console.log(data);
  }, [data]);

  useEffect(() => {
    setSeries(seriesOptions.find(x => x.value == data?.seriesId) ?? generalSeriesOption);
  }, [data, seriesOptions]);

  const renderVideoMoment = (videoMoment) => {
    return (
      <Row className="gx-1">
        <Col md="8">
          <FieldText
            type="text"
            onChange={(x) => {
              videoMoment.name = x.target.value;
              setVideoMoments([...videoMoments]);
            }}
            placeholder="Moment Name"
            value={videoMoment.name}
          />
        </Col>
        <Col md="2" className="d-flex justify-content-center">
          <Button className={`button-remove-small`} title="Remove" onClick={() => {
            setVideoMoments(videoMoments?.filter(x => x != videoMoment));
          }}>
            Remove
          </Button>
        </Col>
        <Col md="2">
          <b>Minute</b>
          <div>{moment.utc(videoMoment.time * 1000).format('H:mm:ss')}</div>

        </Col>
      </Row>);
  }

  return (
    <form onSubmit={handleSave}>
      <Row className="edit-video-archive" style={{ marginTop: 40, display: 'flex', flexDirection: 'row', marginBottom: 40 }}>
        <Col md="10" className="cc-card">
          <h5>Editing Archive</h5>
          <Row>
            <Col md="7">
              <FieldText
                label="Title"
                type="text"
                onChange={(x) => setTitle(x.target.value)}
                placeholder={eventName}
                value={title}
              />
            </Col>
            <Col md="3">
              <FieldSelect
                label={`Series`}
                options={seriesOptions}
                onChange={setSeries}
                value={series}
                placeholder={`Series`}
                required={false}
              />
            </Col>
            <Col md="2">
              <FieldSelect
                label={`Visibility`}
                options={visibilities}
                onChange={setHide}
                value={hide}
                placeholder={`Visibility`}
                required={false}
              />
            </Col>
          </Row>
          <Row>
            <Col md="3">
              <FieldTextarea
                label="Description"
                onChange={(x) => setDescription(x.target.value)}
                placeholder="Description"
                value={description}
                inputClassName={"description-text"}
                style={{ minHeight: 214 }}
              />
            </Col>
            <Col md="3">
              <FieldUploadMultipart
                onUploadComplete={(u) => setCover(u)}
                accept={["image/png", "image/jpg", "image/jpeg"]}
                label={"Event Cover"}
                maxSize={4 * 1024 * 1024 * 1024} // 4 GB
                required={false}
                onStateChanged={setUploading}
                data={cover}
                customPreview={(file) => {
                  return (<div className="video-cover" style={{ backgroundImage: 'url(' + config.API + '/api/file/download/?guid=' + file.guidFile + '&temp=' + (file.id == null) + ')' }}></div>)
                }}
              />
            </Col>
            <Col md="3">
              <FieldUploadMultipart
                onUploadComplete={(u) => setPicture(u)}
                accept={["image/png", "image/jpg", "image/jpeg"]}
                label={"Speaker Picture"}
                maxSize={4 * 1024 * 1024 * 1024} // 4 GB
                required={false}
                onStateChanged={setUploading}
                data={picture}
                customPreview={(file) => {
                  return (<div className="speaker-photo" style={{ backgroundImage: 'url(' + config.API + '/api/file/download/?guid=' + file.guidFile + '&temp=' + (file.id == null) + ')' }}></div>)
                }}
              />
            </Col>
            <Col md="3">
              <FieldUploadMultipart
                onUploadComplete={(u) => setPDF(u)}
                accept={["application/pdf"]}
                label={"PDF"}
                maxSize={4 * 1024 * 1024 * 1024} // 4 GB
                required={false}
                onStateChanged={setUploading}
                data={pdf}
              />
            </Col>
          </Row>
          <Row>
            <Col md="4">
              <FieldText
                label="Speaker Name"
                type="text"
                onChange={(x) => setSpeakerName(x.target.value)}
                placeholder="Speaker Name"
                value={speakerName}
              />
            </Col>
            <Col md="4">
              <FieldText
                label="Speaker Title"
                type="text"
                onChange={(x) => setSpeakerTitle(x.target.value)}
                placeholder="Speaker Title"
                value={speakerTitle}
              />
            </Col>
          </Row>
          <Row>
            <Col md="3">
              <FieldText
                label="External Link (Title)"
                type="text"
                onChange={(x) => setCustomLinkTitle(x.target.value)}
                placeholder="External Link (Title)"
                value={customLinkTitle}
              />
            </Col>
            <Col md="3">
              <FieldText
                label="External Link (URL)"
                onChange={(x) => setCustomLinkUrl(x.target.value)}
                placeholder="External Link (URL)"
                value={customLinkUrl}
                type={"url"}
              />
            </Col>
          </Row>
          <h5>Video Moments</h5>
          {!s3HLSPath && <Row>
            <Col>The video must be converted to create moments.</Col>
          </Row>}

          {s3HLSPath && <Row>
            <Col md="7">
              <Row style={{ display: 'flex', flexDirection: 'column' }}>
                <Col>
                  <VideoJS options={{
                    autoplay: false,
                    controls: true,
                    responsive: true,
                    fluid: true,
                    sources: [{
                      src: s3HLSPath,
                      type: 'application/x-mpegURL'
                    }]
                  }} onReady={handlePlayerReady} />
                </Col>
                <Col>
                  <div className="current-time-display">Minute: <b>{moment.utc(videoTime * 1000).format('H:mm:ss')}</b></div>
                  <Row className="gx-3" >
                    <Col md={10} >
                      <FieldText
                        label="Give this moment a name"
                        type="text"
                        onChange={(x) => setNewMomentName(x.target.value)}
                        placeholder="Moment Name"
                        value={newMomentName}
                      />
                    </Col>
                    <Col md={2}>
                      <Button className="big-square-btn" style={{ marginTop: 29 }} onClick={() => {
                        if (!newMomentName?.trim())
                          return AlertComponent("Error", "Enter the moment name.", { icon: `error` });

                        let newMoments = [...videoMoments];
                        newMoments.push({
                          name: newMomentName,
                          time: videoTime
                        });

                        setVideoMoments(newMoments.sort((a, b) => a.time - b.time));

                        setNewMomentName("");
                      }}>

                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col md="5">
              {videoMoments?.map(x => renderVideoMoment(x))}
            </Col>
          </Row>}
          <Row>
            <Col style={{ marginTop: 40, display: 'flex', justifyContent: 'flex-end' }}>
              <Button className="dark-btn" type="submit">
                Save
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </form >
  );
}

export default VideoArchiveEdit;
